<template>
    <div class="about">
        <Inbanner />
        <div class="container">
            <el-breadcrumb separator="/" style="margin:20px 0;">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>新闻</el-breadcrumb-item>
                <el-breadcrumb-item>{{newstitle}}</el-breadcrumb-item>
            </el-breadcrumb>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <h3 class="text-center">{{newstitle}}</h3>
                    <div class="text-center">
                        <span class="" style="margin-right:50px;"><i class="iconfont">&#xe9bd;</i> 仁迅科技</span> 
                        <span class=""><i class="iconfont">&#xe9bd;</i> {{newstime}}</span> 
                    </div>
                </div>
                <div class="news-content">
                    <div class="text-center"><img src="@/assets/img/news/news_6_1.jpg"></div>
					<p>2021年6月26日，第四届中国生物医药创新合作大会在苏州金鸡湖畔圆满落幕。本次大会以“逐鹿全球医药市场，全面迈向中国创新2.0时代”为主题，为生物医药行业的同仁搭建一个高水准的交流平台，促进行业交流，以此应对行业高速创新发展而带来的挑战。</p>
					<div class="text-center"><img src="@/assets/img/news/news_6_2.png"></div>
					<p><strong>上海凌先医药科技有限公司</strong>受邀出席本次大会并设立展位， 同期举办的6场专题大会之一“第四届创新药及临床试验大会”中的 “新药临床研究与数字化管理”论坛，力邀10+权威学者，300+行业专家共同讨论探索数字化临床研究发展，为行业参会代表带来精彩的专业的主题分享。</p>
					<div class="text-center"><img src="@/assets/img/news/news_6_3.png"></div>
					<p>6月26日下午，<strong>上海凌先药科技有限公司</strong>创始人--<strong>孙忠良</strong>先生，作为本次受邀演讲嘉宾分享了主题为“人机协作实现智能化临床研究管理实践”的专题报告。孙忠良总经理介绍了在临床试验过程中如何实现智能化、数字化项目管理，直击行业痛点，提高临床研究质效，及智能化临床研究未来展望。 </p>
					<div class="text-center"><img src="@/assets/img/news/news_6_4.jpg"></div>
					<p>会议现场，由150+权威专家、1200+业界从业者亲临现场参观学习交流，多位业界从业者莅临凌先医药展台交流互动，了解临床研究智能化解决方案，共同探讨行业发展动向，建立新的合作机会，实现合作共赢。</p>
					<div class="text-center"><img src="@/assets/img/news/news_6_5.png"></div>
					<p>未来，凌先医药创始人孙忠良先生将继续带领团队专注临床研究服务，携手合作伙伴，为制药企业及创新药企业提供智能化临床研究解决方案，提高临床研究质效，共同赋能中国生物医药产业快速发展。</p>
                </div>
            </el-card>
        </div>
    </div>
</template>
<script>
import Inbanner from './pages/Inbanner'
export default{
    data() {
        return {
            newstitle: 'iTrial Genies智能数字化临床试验平台产品发布会',
            newstime: '2020.10.16',
        };
    },
    components:{
        Inbanner
    }
}
</script>
<style>
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
h2 {
    font-size: 22px;
    margin: 30px 0;
    font-weight: 700;
}
.news-content img{
    max-width:100%;
}
.news-content p{
    text-indent:2em;
    font-size:14px;
    margin-bottom: 20px;
}
.news-content ol li{
    list-style: square;
    margin-left: 30px;
}
.news-content ol li p{
    text-indent:0em;
    
}
</style>